// extracted by mini-css-extract-plugin
export var callCard = "_o0-0";
export var callMessageButton = "_o0-1";
export var helpIcon = "_o0-3";
export var helpIconContainer = "_o0-4";
export var verticalDivider = "_o0-2";